module.exports = "//public.zight.com/packs/media/images/onboarding/icons-mac-os-app-e3cd35b0e72c2659859c3375cbfd2016.png";